export default {"src":"/_next/static/media/IBM.bc4e496f.svg","height":18,"width":18};